import React, { useState, useCallback, useEffect } from "react";
import {
  Modal,
  Box,
  Grid,
  TextField,
  Button,
  IconButton,
  Typography,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { showLoader, hideLoader } from "../../../../redux/loader/actions";
import { showSnackbar } from "../../../../redux/snackbar/actions";
import productCategoryApi from "../../../../services/product_category";
import productApi from "../../../../services/product";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #ccc",
  boxShadow: 24,
  p: 4,
  maxHeight: "80vh",
  overflowY: "auto",
};

const ProductCreationModal = ({
  open,
  onClose,
  mode,
  product,
  getAllProduct,
  fileId,
  setFileId,
}) => {
  const [productCategory, setProductCategory] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [entityUUID, setEntityUUID] = useState([]);
  const [selectedHsnCode, setSelectedHsnCode] = useState([]);
  const [entityID, setEntityID] = useState("");
  const [hsn, setHSN] = useState("");
  const [entity, setEntity] = useState([]);
  const [entityHSN, setEntityHSN] = useState([]);
  const [initialValues, setInitialValues] = useState(null);
  const dispatch = useDispatch();

  const getAllProductCategory = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setProductCategory(
          res?.data?.data.map((item) => ({ name: item.name, id: item.id }))
        );
      }
    };

    const onFailure = (err) => {
      console.error("API call failed:", err);
    };

    productCategoryApi.getAllProductCategory().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    if (open) {
      getAllProductCategory();
    }
  }, [getAllProductCategory, open]);

  const getAllentity = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setEntity(res?.data?.data);
      }
    };

    const onFailure = (err) => {
      console.error("API call failed:", err);
    };

    productApi.getallentity().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    if (open) {
      getAllentity();
    }
  }, [open]);

  const getEntityById = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setEntityHSN(res?.data?.data);
      }
    };

    const onFailure = (err) => {
      console.error("API call failed:", err);
    };

    productApi.getAllEntityuuid(entityUUID).then(onSuccess, onFailure);
  }, [entityUUID]);

  useEffect(() => {
    if (entityUUID) {
      getEntityById();
    }
  }, [entityUUID, getEntityById]);

  const createProductCategory = useCallback(() => {
    const data = { name: inputValue };

    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        const newCategory = res.data.data;
        setProductCategory([
          ...productCategory,
          { name: newCategory.name, id: newCategory.id },
        ]);
        formik.setFieldValue("variant", newCategory.name);
        formik.setFieldValue("categoryId", newCategory.id);
      }
    };

    const onFailure = (err) => {
      console.error("API call failed:", err);
    };

    productCategoryApi.createProductCategory(data).then(onSuccess, onFailure);
  }, [inputValue, productCategory]);

  const handleSubmit = (formData) => {
    if (!fileId && mode !== "edit") {
      dispatch(
        showSnackbar({
          message: "Upload product logo",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    }
    const data = {
      name: formData?.name,
      product_category: formData?.categoryId,
      entity: entityID,
      hsn_code: hsn,
      product_alias_name: formData?.alias_name,
      product_url: formData?.product_url,
      product_login_url: formData?.login_url,
      description: formData?.description,
      file_id: fileId,
    };
    const id = product?.uuid;
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.msg || "Info updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        onClose();
        getAllProduct();
        formik.resetForm();
        setFileId();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.msg,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    if (mode === "edit") {
      productApi.updateProduct(id, data).then(onSuccess, onFailure);
    } else {
      productApi.createProduct(data).then(onSuccess, onFailure);
    }
  };
  const formik = useFormik({
    initialValues: {
      name: "",
      variant: "",
      categoryId: "",
      entity: "",
      hsncode: "",
      alias_name: "",
      description: "",
      product_url: "",
      login_url: "",
      logo: null,
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Product Name is required")
        .min(3, "Product Name have atleast 3 characters")
        .max(50, "Product Name cannot exceed 50 characters"),
      variant: Yup.string().required("Category is required"),
      entity: Yup.object().nullable().required("Entity is required"),
      hsncode: Yup.string().required("HSN Code is required"),
      alias_name: Yup.string()
        .required("Alias Name is required")
        .max(5, "Alias Name cannot exceed 5 characters"),

      description: Yup.string()
        .required("Description is required")
        .max(250, "Alias Name cannot exceed 250 characters"),
      product_url: Yup.string()
        .url("Invalid URL")
        .required("Product URL is required"),
      login_url: Yup.string()
        .url("Invalid URL")
        .required("Login URL is required"),
      logo: Yup.mixed().required("Logo is required").nullable(),
    }),
    onSubmit: handleSubmit,
  });
  useEffect(() => {
    if (mode === "edit" && product) {
      const productName = product?.name || "";
      const productCategoryName = product?.productCategory?.name || "";
      const productCategoryId = product?.productCategory?.id || "";
      const productEntity = product?.entityDetails || {};
      const productHSNCode = product?.hsn_code || "";
      const aliasName = product?.product_alias_name || "";
      const description = product?.description || "";
      const productUrl = product?.product_url || "";
      const loginUrl = product?.product_login_url || "";
      const logo = product?.file?.file_id || null;
      setHSN(product?.hsn_code);
      setEntityID(product?.entityDetails?.entity_id);
      setFileId(product?.file?.file_id);
      setInitialValues({
        name: productName,
        variant: productCategoryName,
        categoryId: productCategoryId,
        entity: productEntity,
        hsncode: productHSNCode,
        alias_name: aliasName,
        description: description,
        product_url: productUrl,
        login_url: loginUrl,
        logo: logo,
      });

      formik.setValues({
        name: productName,
        variant: productCategoryName,
        categoryId: productCategoryId,
        entity: productEntity,
        hsncode: productHSNCode,
        alias_name: aliasName,
        description: description,
        product_url: productUrl,
        login_url: loginUrl,
        logo: logo,
      });
    } else {
      formik.resetForm();
      setInitialValues(null);
    }
  }, [mode, product]);

  const isFormChanged = () => {
    if (!initialValues) return false;
    return JSON.stringify(formik.values) !== JSON.stringify(initialValues);
  };

  const logoUpload = (file) => {
    dispatch(showLoader());
    if (!file) {
      console.error("No file selected");
      return;
    }
    const formData = new FormData();
    formData.append("FILE", file);
    productApi
      .productUpload(formData)
      .then((res) => {
        dispatch(hideLoader());
        if (res?.data?.status) {
          dispatch(
            showSnackbar({
              message: res?.data?.msg,
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            })
          );
          setFileId(res?.data?.file?.fileId);
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error("Logo upload failed:", err?.response?.data);
      });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{ style: { pointerEvents: "none" } }}
    >
      <Box sx={style}>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" gutterBottom>
          {mode === "edit" ? "Edit Product" : "Create Product"}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Product Name"
              variant="outlined"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Product Alias Name"
              variant="outlined"
              name="alias_name"
              value={formik.values.alias_name}
              onChange={formik.handleChange}
              error={
                formik.touched.alias_name && Boolean(formik.errors.alias_name)
              }
              helperText={formik.touched.alias_name && formik.errors.alias_name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Description"
              variant="outlined"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Product URL"
              variant="outlined"
              name="product_url"
              value={formik.values.product_url}
              onChange={formik.handleChange}
              error={
                formik.touched.product_url && Boolean(formik.errors.product_url)
              }
              helperText={
                formik.touched.product_url && formik.errors.product_url
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Product Login URL"
              variant="outlined"
              name="login_url"
              value={formik.values.login_url}
              onChange={formik.handleChange}
              error={
                formik.touched.login_url && Boolean(formik.errors.login_url)
              }
              helperText={formik.touched.login_url && formik.errors.login_url}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              freeSolo
              options={productCategory.map((category) => category.name)}
              value={formik.values.variant}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              onChange={(event, newValue) => {
                if (newValue && newValue.startsWith('Add "')) {
                  const trimmedValue = newValue.slice(5, -1);
                  formik.setFieldValue("variant", trimmedValue);
                  createProductCategory(trimmedValue);
                } else {
                  const selectedCategory = productCategory.find(
                    (cat) => cat.name === newValue
                  );
                  if (selectedCategory) {
                    formik.setFieldValue("variant", selectedCategory.name);
                    formik.setFieldValue("categoryId", selectedCategory.id);
                  } else {
                    formik.setFieldValue("variant", newValue || "");
                    formik.setFieldValue("categoryId", "");
                  }
                }
              }}
              filterOptions={(options, params) => {
                const filtered = options.filter((option) =>
                  option.toLowerCase().includes(params.inputValue.toLowerCase())
                );
                if (
                  params.inputValue !== "" &&
                  !filtered.includes(params.inputValue)
                ) {
                  filtered.push(`Add "${params.inputValue}"`);
                }
                return filtered;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  variant="outlined"
                  name="variant"
                  error={
                    formik.touched.variant && Boolean(formik.errors.variant)
                  }
                  helperText={formik.touched.variant && formik.errors.variant}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              disablePortal
              fullWidth
              options={entity}
              getOptionLabel={(option) => option.entity_name || ""}
              value={formik.values.entity}
              onChange={(event, value) => {
                formik.setFieldValue("entity", value || null);
                formik.setFieldValue("hsncode", "");
                if (value) {
                  setEntityID(value.entity_id);
                  setEntityUUID(value.entity_uuid);
                  if (
                    value.entity_hsn_code &&
                    value.entity_hsn_code.length > 0
                  ) {
                    setHSN(value.entity_hsn_code[0]);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Entity"
                  name="entity"
                  error={formik.touched.entity && Boolean(formik.errors.entity)}
                  helperText={formik.touched.entity && formik.errors.entity}
                  fullWidth
                  onBlur={() => formik.setFieldTouched("entity")}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              fullWidth
              disablePortal
              options={entityHSN?.entity_hsn_code || []}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="HSN Code"
                  name="hsncode"
                  error={
                    formik.touched.hsncode && Boolean(formik.errors.hsncode)
                  }
                  helperText={formik.touched.hsncode && formik.errors.hsncode}
                  fullWidth
                  onBlur={() => formik.setFieldTouched("hsncode")}
                />
              )}
              value={formik.values.hsncode}
              onChange={(event, newValue) => {
                formik.setFieldValue("hsncode", newValue);
                setSelectedHsnCode(newValue);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Button
              variant="contained"
              component="label"
              fullWidth
              color="primary"
            >
              Upload Logo
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file) {
                    formik.setFieldValue("logo", file);
                    logoUpload(file);
                  }
                }}
              />
            </Button>
            {formik.touched.logo && formik.errors.logo && (
              <Typography variant="body2" color="error">
                {formik.errors.logo}
              </Typography>
            )}
            {!fileId ? (
              <Typography
                variant="subtite2"
                color="error"
                sx={{ fontSize: "12px" }}
              >
                Logo Required
              </Typography>
            ) : null}
          </Grid>

          <Grid item xs={12} sm={12} md={12} style={{ textAlign: "right" }}>
            {mode === "edit" && isFormChanged() && (
              <Button
                variant="contained"
                sx={{
                  height: "100%",
                  background:
                    "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  color: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
                  },
                  width: { xs: "100%", sm: "auto" },
                }}
                onClick={formik.handleSubmit}
              >
                Update Product
              </Button>
            )}
            {mode === "create" && (
              <Button
                variant="contained"
                sx={{
                  height: "100%",
                  background:
                    "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  color: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
                  },
                  width: { xs: "100%", sm: "auto" },
                }}
                onClick={formik.handleSubmit}
              >
                Add Product
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ProductCreationModal;
